import { useQuery } from '@apollo/client'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Image from 'next/future/image'
import Layout from '../components/layouts/AppLayout'
import Head from 'next/head'
import { GET_DISTRIBUTORS } from '../services/graphql/queries/getUsers'
import { useCountries } from '../hooks/useCountries'

export default function Distributors () {
  const { translate } = useCountries()
  const { data } = useQuery(GET_DISTRIBUTORS, {
    variables: {
      page: 1,
      first: 100
    }
  })
  const { t } = useTranslation(['distributor', 'languages'])

  return (
    <Layout variant="white">
      <Head>
        <title>{t('public.meta.title')}</title>
      </Head>
      <div className="container py-5">
        <div className="row px-2">
          <div className="col-12">
            <h1 className="text-dark fw-bold mb-4">{t('public.title')}</h1>
            <ul className="row unlist list-unstyled gx-md-5 gx-0 gy-5">
              {data?.distributors.data.map(user => (
                <li key={user.id}
                  className="col-lg-4 col-md-6 col-12"
                >
                  <div className="bg-light-blue p-5 d-flex flex-column h-100">
                    <Link href={`/seller/${user.company.slug}`}
                      key={user.id}
                    >
                      <a className="text-decoration-none text-dark">
                        <div className="rounded mb-3">
                          <Image
                            alt=""
                            width={user.company.logo.width}
                            height={user.company.logo.height}
                            src={user.company.logo.url}
                            className="w-25 h-auto"
                          />
                        </div>
                        <h2 className="fs-3">{user.full_name}</h2>
                      </a>
                    </Link>
                    <hr className="opacity-25"/>
                    <span className="fw-bold text-primary fs-6 text-uppercase mt-2 d-block">
                      {
                      user.countries.length > 0 ? t('public.available_in') : t('public.none_available')
                    }
                    </span>
                    {
                      user.countries.length > 0 && (
                        <ul className="list-unstyled mt-3 d-flex flex-wrap gap-2">
                          {
                            user.countries.map(country => (
                              <li className="badge text-bg-primary"
                                key={country.id}
                              >
                                {translate(country)}
                              </li>
                            ))
                          }
                        </ul>
                      )
                    }
                    <Link href={`mailto:${user.email}`}>
                      <a className="btn btn-outline-primary mt-4">
                        {t('public.send_mail')}
                      </a>
                    </Link>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export async function getServerSideProps ({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['distributor', 'header', 'footer', 'languages', 'countries', 'applications', 'routes']))
    }
  }
}
